import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'arrow']

  static values = {
    campPage: { type: Boolean, default: false }
  }

  toggle(event) {
    const content = this.contentTarget
    const arrow = this.arrowTarget


    // Determine highlight class based on campPageValue
    const highlightClass = this.campPageValue
      ? '!text-brand-bright-green'
      : '!text-brand-primary'

    // Toggle the appropriate highlight class
    const titleDiv = event.currentTarget.querySelector('div')
    titleDiv.classList.toggle(highlightClass)

    // Toggle accordion content and arrow
    content.classList.toggle('hidden')
    arrow.classList.toggle('rotate-180')
  }
}
